import Head from 'next/head';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import StaticTable from 'components/StaticTable/StaticTable';
import type { AppState } from 'stores';

import styles from './StaticPage.module.scss';

interface StaticPageProps {
  ssrReduxState: AppState;
  page: {
    items: Array<any>;
  };
  tableData: Array<any>;
}

const StaticPage: React.FC<StaticPageProps> = (props) => {
  const { page } = props;
  const {
    title,
    block: { json },
  } = page.items[0];

  const RICHTEXT_OPTIONS = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_: any, children: any) => <p>{children}</p>,
      [BLOCKS.EMBEDDED_ENTRY]: ({ data }: any) => {
        if (data.target.sys.id) {
          return <StaticTable {...props} />;
        }
        return null;
      },
      [INLINES.HYPERLINK]: ({ data }: any, children: any) => {
        if (data.uri.includes('https://embed.cdn-surfline.com/cam')) {
          return (
            <div className={styles.slCamEmbed}>
              <iframe src={data.uri} title="Camera Embed" allowFullScreen />
            </div>
          );
        }
        return <a href={data.uri}>{children}</a>;
      },
    },
  };

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <div className={styles.hentry}>
        <h2>{title}</h2>
        {documentToReactComponents(json, RICHTEXT_OPTIONS)}
      </div>
    </>
  );
};

export default StaticPage;
